import { ReactElement } from 'react';
import styled from 'styled-components';
import Image from 'next/future/image';

import TopMainLayout from '@/layouts/topMainNavigator';
import BottomTabLayouts from '@/layouts/bottomTab';
import useCheckQuestionEnrollState from '@/hooks/InA/useCheckQuestionEnrollState';
import BottomFixedButton from '@/components/Button/BottomFixedButton';
import QNAExplain from '@/containers/ina/index/QNAExplain';
import Search from '@/containers/ina/index/Search';
import QuestionList from '@/containers/ina/index/QuestionList';
import { IInAList } from '@/models/ina';
import { GetEnrolledQuestionList } from '@/queries/ina/index/getEnrolledQuestionList';
import { URLs } from '@/api';
import { FontStyle } from '@/utils/StyleUtil';

const QNAPage = ({ inaList }: { inaList?: IInAList }) => {
    const { onClickEnrollQuestion } = useCheckQuestionEnrollState();
    GetEnrolledQuestionList();

    return (
        <>
            <Container>
                <QNAExplain />
                {/*<Search />*/}
                <QuestionList inaList={inaList} />
                {/*<BottomFixedButton*/}
                {/*    buttonColor="#0ec4cf"*/}
                {/*    text="나의 질문 등록하기"*/}
                {/*    onClickButton={() => onClickEnrollQuestion()}*/}
                {/*    hasBottomNavi*/}
                {/*/>*/}
                <AskQuestion onClick={() => onClickEnrollQuestion()}>
                    <Image
                        src="/img/ina/ico_ask_question.png"
                        alt="ask"
                        width="18"
                        height="18"
                        style={{ marginTop: '3px' }}
                    />
                    질문하기
                </AskQuestion>
            </Container>
        </>
    );
};

QNAPage.getTopLayout = (page: ReactElement) => {
    return (
        <TopMainLayout title="보험Q&A" rightButton="alarm">
            {page}
        </TopMainLayout>
    );
};

QNAPage.getBottomLayout = (page: ReactElement) => {
    return (
        <BottomTabLayouts selectedItemKey="ina" paddingSize={70}>
            {page}
        </BottomTabLayouts>
    );
};

export const getServerSideProps = async ({ query }: { query: { page: number } }) => {
    try {
        const url = URLs.ina.questionList;

        let all;
        if (query.page) all = await fetch(url + `?category=0&page=${query.page}`);
        else all = await fetch(url + `?category=0`);

        const insuranceClaim = await fetch(url + '?category=1');
        const productInquiry = await fetch(url + '?category=2');
        const guaranteeAnalysis = await fetch(url + '?category=3');
        const diseaseInquiry = await fetch(url + '?category=4');
        const etcInquiry = await fetch(url + '?category=5');

        const allList = await all.json();
        const insuranceClaimList = await insuranceClaim.json();
        const productInquiryList = await productInquiry.json();
        const guaranteeAnalysisList = await guaranteeAnalysis.json();
        const diseaseInquiryList = await diseaseInquiry.json();
        const etcInquiryList = await etcInquiry.json();

        return {
            props: {
                inaList: {
                    allList: allList.data,
                    insuranceClaimList: insuranceClaimList.data,
                    productInquiryList: productInquiryList.data,
                    guaranteeAnalysisList: guaranteeAnalysisList.data,
                    diseaseInquiryList: diseaseInquiryList.data,
                    etcInquiryList: etcInquiryList.data,
                },
            },
        };
    } catch (error) {
        return {
            props: {
                inaList: null,
            },
        };
    }
};

const Container = styled.div`
    //padding-bottom: 30px;
    background-color: #fff;
`;

const AskQuestion = styled.button`
    display: flex;
    position: sticky;
    float: right;
    bottom: 76px;
    margin-right: 20px;
    width: 112px;

    flex-direction: row;
    gap: 5px;
    border-radius: 29px;
    background: #0ec4cf;
    padding: 12px 20px;
    ${FontStyle(14, 22, '500', '#fff', -1)};
`;

export default QNAPage;
